<template>
  <div class="grid cols-[1fr_auto]">
    <p id="filter-pickup-label" class="text-md fw-bold">
      {{ $t.inStorePickup }}
    </p>
    <vf-switch
      v-model="isPickup"
      aria-labelledby="filter-pickup-label"
      class="row-span-2 ml-8 self-center justify-self-end"
    />
    <div class="flex gap-x-2 gap-y-1 text-xs wrap">
      <p v-if="bopis.selectedStore">
        {{ bopis.selectedStore?.name }}
      </p>
      <base-button class="capitalize underlined" @click="handleOpenDialog()">
        {{ bopis.selectedStore ? $t.changeStore.title : $t.selectStore }}
      </base-button>
    </div>
    <dialog-bopis-store-search />
  </div>
</template>

<script lang="ts" setup>
const bopis = useBopisStore()
const storeFilter = useRouteQuery<string | undefined>('storeFilter')
const DialogBopisStoreSearch = createDialog('bopis-store-search', {
  type: { sm: 'panel', lg: 'modal' },
})

const handleOpenDialog = () => {
  DialogBopisStoreSearch.keep().open({ showSaveButton: true, ignoreInventoryCheck: true }).then(() => {
    if (bopis.selectedStore?.storeid) storeFilter.value = bopis.selectedStore.storeid
    else storeFilter.value = undefined
  })
}

const isPickup = computed({
  get: () => !!storeFilter.value,
  set: (value: boolean) => {
    if (value && !bopis.selectedStore) {
      handleOpenDialog()
    }
    else {
      storeFilter.value = value && bopis.selectedStore ? bopis.selectedStore.storeid : undefined
    }
  }
})
</script>
